<template>
  <article class="" v-if="charged">
    <div class="table_card">
      <div class="table_card__head">
        <v-layout row wrap>
          <v-flex lg12>
            <p class="table_card__head--title">Editar sublocación {{sublocation.attributes.name}}</p>
              <v-breadcrumbs class="breadcums">
                <v-icon slot="divider">chevron_right</v-icon>
                <v-breadcrumbs-item
                  @click="$router.push({name: 'location_access', params: {id: originalLocation.id}})"
                  class="breadcums__option"
                >
                  {{originalLocation.name}}
                </v-breadcrumbs-item>
                <v-breadcrumbs-item
                  disabled
                  class="breadcums__disable"
                >
                  {{sublocation.attributes.name}}
                </v-breadcrumbs-item>
              </v-breadcrumbs>
          </v-flex>
        </v-layout>
      </div>
      <div class="table_card__body">
        <v-layout row wrap>
        <v-flex xs12 style="display:flex">
          <v-flex xs5>
            <span class="table_card__info--label">Seleccionar sede</span>
            <v-select
              label="Seleccionar sede"
              :items="locations"
              item-value="id"
              item-text="name"
              v-model="sublocation.attributes.location_id"
              single-line
              dense
              solo
              color="#1476FB"
            ></v-select>
          </v-flex>
          <v-flex xs6 class="pl-5">
            <span class="table_card__info--label" style="white-space: nowrap;">Nombre del lugar de entrenamiento</span>
            <input
              class="faccess_input"
              type="text"
              name="Name"
              placeholder="Nombre de la locación"
              v-model="sublocation.attributes.name"
            >
          </v-flex>
        </v-flex>
        <!-- <v-flex xs12 style="display:flex">
          <v-flex xs5>
            <span class="table_card__info--label" style="white-space: nowrap;">Correo</span>
            <input
              class="faccess_input"
              type="email"
              name="Email"
              placeholder="Correo electrónico"
              v-model="sublocation.attributes.email"
            >
          </v-flex>
          <v-flex xs6 class="pl-5">
            <span class="table_card__info--label" style="white-space: nowrap;">Celular</span>
            <input
              class="faccess_input"
              type="text"
              name="Mobile"
              placeholder="Número de teléfono celular"
              v-model="sublocation.attributes.mobile"
            >
          </v-flex>
        </v-flex> -->
      </v-layout>
      </div>
    </div>

    <div class="table_card mt-5">
      <div class="table_card__head">
        <p class="table_card__head--title">Selecciona tus horarios</p>
      </div>
      <div class="table_card__body">
        <v-flex xs8 style="margin-left:40px">
          <div
            class="data_card__create_button--info" style="width:90%"
          >
            <v-flex xs4> {{days[actual_day].name_esp}} </v-flex>
            <v-flex xs2></v-flex>
            <v-flex xs5> <b>{{timeBoxes[actual_day].max_spaces}} / {{maximum_spaces[actual_day]}} cupos </b></v-flex>
          </div>
        </v-flex>
        <v-flex
          xs12
          style="display:flex; margin: 50px 3% 0px 3%;"
        >
            <v-layout
                row wrap justify-space-between>
              <v-flex  v-for="day in days"
                :key="day.name"
                v-if="day.name!='sunday'||isWeekendActive"
                class="data_card__headers--days"
                :style="day.name==actual_day?
                          !scheduleIsInError?'margin-top:-12px !important;background:#FFF':'margin-top:-12px !important;background:#FFF;cursor:not-allowed;' :
                          !scheduleIsInError?'': 'cursor:not-allowed;'"
                @click="!scheduleIsInError?actual_day=day.name:''">
                <span class="data_card__info--label"
                      :style="day.name==actual_day?'font-weight:600;color:#5A6B8E':''">
                      {{ day.name_esp | capitalize }}
                </span>
              </v-flex>
            </v-layout>
        </v-flex>
        <v-flex
          xs12
          style="display:flex; margin: 0px 3% 0px 3%;">
            <v-layout
                row wrap justify-space-between>
              <v-flex  v-for="day in days"
                :key="day.name"
                v-if="day.name!='sunday'||isWeekendActive"
                class="data_card__headers--days--transparency"
                :style="day.name==actual_day?
                          !scheduleIsInError?'margin-top:-12px !important;background:#FFF':'margin-top:-12px !important;background:#FFF;cursor:not-allowed;' :
                          !scheduleIsInError?'': 'cursor:not-allowed;'"
                @click="!scheduleIsInError?actual_day=day.name:''">
              </v-flex>
            </v-layout>
        </v-flex>
        <section class="trainers__create_container data_card__headers--days--panel" >
          <v-layout row wrap>
            <v-flex xs12>
              <v-flex
                xs12 >
                <v-layout row wrap style="justify-content:space-evenly">
                  <v-flex xs3>
                    <span class="table_card__info--label">Apertura</span>
                    <vue-timepicker :class="!errorOpening?'data_card__info--select--time':'data_card__info--select--time--error'"
                        style="margin-left:0 !important"
                        format="hh:mm a"
                        placeholder="Apertura"
                        :hour-range="[startRange]"
                        :minute-range="[startMinutesRange]"
                        :minute-interval="5"
                        auto-scroll
                        close-on-complete
                        input-width="95%"
                        @input="checkOpening()"
                        @change="updateShowModal()"
                        v-model="timeBoxes[actual_day].begin"
                        hour-label="Horas" minute-label="mins" apm-label="AM/PM"
                        hide-clear-button></vue-timepicker>
                  </v-flex>
                  <v-flex xs3>
                    <span class="table_card__info--label">Cierre</span>
                    <vue-timepicker :class="!errorEnding?'data_card__info--select--time':'data_card__info--select--time--error'"
                        style="margin-left:0 !important;"
                        format="hh:mm a"
                        placeholder="Cierre"
                        :minute-interval="5"
                        :minute-range="[endMinutesRange]"
                        auto-scroll
                        close-on-complete
                        input-width="95%"
                        v-model="timeBoxes[actual_day].end"
                        :hour-range="[endRange]"
                        hour-label="Horas" minute-label="mins" apm-label="AM/PM"
                        @change="checkEnding()"
                        hide-clear-button></vue-timepicker>
                  </v-flex>
                  <v-flex xs1>
                    <span class="table_card__info--label">Cupos</span>
                    <input
                      :class="!spacesInError?'data_card__info--input--number':'data_card__info--input--number--error'"
                      type="number"
                      name="nationality_code"
                      @keypress="isNumberValid($event)"
                      @blur="isFinalNumberValid($event,days[actual_day])"
                      v-model="timeBoxes[actual_day].max_spaces"
                      @input="reviewSpaces()"
                    >
                  </v-flex>
                  <v-flex xs2>
                    <span class="table_card__info--label" style="white-space:nowrap">Tiempo estadía:</span>
                    <vue-timepicker class="data_card__info--select--time"
                        format="H h mm"
                        placeholder="Tiempo estadía"
                        :hour-range="[maxTimeStay.hh]"
                        :minute-range="[[maxTimeStay.mm,maxMM]]"
                        :minute-interval="5"
                        input-width="95%"
                        v-model="timeBoxes[actual_day].stay_time"
                        close-on-complete
                        hour-label="Horas" minute-label="mins" apm-label="AM/PM"
                        hide-clear-button
                        @change="setNewSpaces()"
                        :disabled="timeBoxes[actual_day].max_spaces == 0"
                        ></vue-timepicker>
                  </v-flex>
                  <!-- :minute-range="[maxTimeStay.mm,maxMM]" -->
                  <v-flex xs2>
                    <span class="table_card__info--label">Reservas cada:</span>
                    <vue-timepicker class="data_card__info--select--time"
                        format="H h mm"
                        placeholder="Frecuencia"
                        :hour-range="[0,bookEvery.hh]"
                        :minute-range="[0,[bookMM,bookEvery.mm]]"
                        :minute-interval="5"
                        input-width="95%"
                        v-model="timeBoxes[actual_day].frequency"
                        close-on-complete
                        hour-label="Horas" minute-label="mins" apm-label="AM/PM"
                        hide-clear-button
                        :disabled="timeBoxes[actual_day].max_spaces == 0"
                        @change="setNewSpaces()"></vue-timepicker>
                      <div class="data_card__create_button--info--booking"
                      :style="validate_quota?'background-color:#FFCA00;color:#000000;':''">
                        <b style="text-align: center;"
                        >{{days[actual_day].spaces_per_booking}} personas por turno</b>
                      </div>
                  </v-flex>
                </v-layout>
              </v-flex>
            </v-flex>
            <v-flex
                xs12 >
                <v-layout row wrap style="justify-content:space-evenly">
                  <v-flex xs6>
                    <p v-if="time_zone !== timeZoneLocal"
                      style="color:rgb(255, 134, 0);margin-top: 10px;font-size:14px;font-weight:500;"
                    >Los horarios serán los correspondientes a la hora de {{ location_time_zone }}, {{ country }} ( GMT{{gtm}} )*</p>
                  </v-flex>
                  <v-flex xs3>
                    <div class="data_card__create_button--info--data__data_connector" >
                    </div>
                    <div
                      class="data_card__create_button--info--data">
                    <p>El máximo de personas en tu sublocación es de <b>{{timeBoxes[actual_day].max_spaces}} personas</b> </p>
                    </div>
                  </v-flex>
                  <v-flex xs2></v-flex>
                </v-layout>
            </v-flex>
          </v-layout>
          <!-- Inactive times section -->
          <v-layout>
            <div class="offer_elements__condition--inactive_time_container">
              <div class="offer_elements__condition--requirement" v-for="(inactive_time, index) in days[actual_day].inactive_times" :key="index">
                <v-flex xs12>
                  <span class="data_card__info--label--hours">Hora Inicio</span>
                  <vue-timepicker :class="!inactive_time.errorStart?'data_card__info--select--time':'data_card__info--select--time--error'"
                  style="margin-left:0 !important"
                  format="hh:mm a"
                  placeholder="Inicio Inactividad"
                  :hour-range="[startRange]"
                  :minute-interval="5"
                  auto-scroll
                  close-on-complete
                  input-width="95%"
                  v-model="inactive_time.start_time"
                  @change="validateInactiveTimes()"
                  hour-label="Horas" minute-label="mins" apm-label="AM/PM"
                  hide-clear-button></vue-timepicker>

                  <v-flex xs12>
                    <span class="data_card__info--label--hours">Hora Fin</span>
                    <vue-timepicker :class="!inactive_time.errorEnd?'data_card__info--select--time':'data_card__info--select--time--error'"
                        style="margin-left:0 !important;"
                        format="hh:mm a"
                        placeholder="Fin Inactividad"
                        :minute-interval="5"
                        auto-scroll
                        close-on-complete
                        input-width="95%"
                        v-model="inactive_time.end_time"
                        :hour-range="[endRange]"
                        hour-label="Horas" minute-label="mins" apm-label="AM/PM"
                        @change="validateInactiveTimes()"
                        hide-clear-button></vue-timepicker>
                  </v-flex>
                </v-flex>
                <v-hover style="margin-left: auto; margin-right: auto; margin-top: 10px;" title="Eliminar tiempo inactivo">
                  <button @click="removeInactiveTime(actual_day ,index)" slot-scope="{ hover }" :class="hover?'offer_elements__interaction--hover_delete':''" class="offer_elements__button--add_requirement with_box_shadow offer_elements__interaction--border_gray">
                    <div class="offer_elements__button--delete_requirement " :class="hover?'offer_elements__interaction--hover_delete_background':''">
                      <p>x</p>
                    </div>
                  </button>
                </v-hover>
              </div>
              <v-flex xs12>
                <p class="agreement__text--small_gray ">Añadir Tiempo Inactivo</p>
                <div class="offer_elements__condition--add_container">
                  <v-hover>
                      <button @click="addInactiveTime(actual_day)" slot-scope="{ hover }" :class="hover?'accessIndex__interaction--hover_add':''" class="offer_elements__button--add_requirement with_box_shadow offer_elements__interaction--border_blue">
                        <p>+</p>
                      </button>
                  </v-hover>
                </div>
              </v-flex >
            </div>
          </v-layout>
          <!-- end inactive times section -->
        </section>

        <confirm-modal v-if="show_advertisement_modal" @confirm-action="confirmSave"></confirm-modal>
      </div>
      <div class="table_card__footer">
        <button
          :class="formIsInError?'data_card__create_button--solid--error':'faccess_button'"
          @click="formIsInError?'':validateScheduleChanges()"
        >
          Guardar sublocación
        </button>
      </div>
    </div>


    <!-- <div>
      <h1>Parametros</h1>
      <h3>Reservas Cada</h3>
      <p>[0,bookEvery.hh] {{ [0,bookEvery.hh] }}</p>
      <p>[bookMM,bookEvery.mm] {{ [bookMM,bookEvery.mm] }}</p>
      <p> bookMM {{  bookMM }}</p>
      <p>book_hh_minutes {{ book_hh_minutes }}</p>
      <p>this.book_mm {{ book_mm }}</p>
      <p>this.book_every {{ book_every }}</p>
      <p>book_every_minutes {{ book_every_minutes }}</p>
      <p>----------------------------------------</p>
      <h3>Tiempo estadía</h3>
      <p>[maxTimeStay.hh] {{ [maxTimeStay.hh] }}</p>
      <p>[[maxTimeStay.mm,maxMM]] {{ [[maxTimeStay.mm,maxMM]] }}</p>
      <p>maxMM {{ maxMM }}</p>
      <p>max_hh_minutes {{ max_hh_minutes }}</p>
      <p>max_mm {{ max_mm }}</p>
      <p>time_stay {{ time_stay }}</p>
    </div> -->
  </article>
</template>

<script>
import VueTimepicker from 'vue2-timepicker/src/vue-timepicker.vue'
export default {
  data(){
    return{
      locations: [],
      sublocation: {},
      actual_day:"monday",
      errorEnding:false,
      errorOpening:false,
      charged: false,
      originalLocation:{
        id:0,
        name:'Sublocation'
      } ,
      days: {
        monday:     {name: 'monday',
                     begin:'',
                     end:'',
                     max_spaces:0,
                     spaces_per_booking:0,
                     frequency:"0 h 00",
                     stay_time:"0 h 00",
                     type:'string',
                     name_esp: 'lunes',
                     inactive_times: []
                    },
        tuesday:    {name: 'tuesday',
                     begin:'',
                     end:'',
                     max_spaces:0,
                     spaces_per_booking:0,
                     frequency:"0 h 00",
                     stay_time:"0 h 00",
                     type:'string',
                     name_esp: 'martes',
                     inactive_times: []
                    },
        wednesday:  {name: 'wednesday',
                     begin:'',
                     end:'',
                     max_spaces:0,
                     spaces_per_booking:0,
                     frequency:"0 h 00",
                     stay_time:"0 h 00",
                     type:'string',
                     name_esp: 'miércoles',
                     inactive_times: []
                    },
        thursday:   {name: 'thursday',
                     begin:'',
                     end:'',
                     max_spaces:0,
                     spaces_per_booking:0,
                     frequency:"0 h 00",
                     stay_time:"0 h 00",
                     type:'string',
                     name_esp: 'jueves',
                     inactive_times: []
                    },
        friday:     {name: 'friday',
                     begin:'',
                     end:'',
                     max_spaces:0,
                     spaces_per_booking:0,
                     frequency:"0 h 00",
                     stay_time:"0 h 00",
                     type:'string',
                     name_esp: 'viernes',
                     inactive_times: []
                    },
        saturday:   {name: 'saturday',
                     begin:'',
                     end:'',
                     max_spaces:0,
                     spaces_per_booking:0,
                     frequency:"0 h 00",
                     stay_time:"0 h 00",
                     type:'string',
                     name_esp: 'sábado',
                     inactive_times: []
                    },
        sunday:     {name: 'sunday',
                     begin:'',
                     end:'',
                     max_spaces:0,
                     spaces_per_booking:0,
                     frequency:"0 h 00",
                     stay_time:"0 h 00",
                     type:'string',
                     name_esp: 'domingo',
                     inactive_times: []
                    }
      },
      timeBoxes:{
        monday:     {
                     begin:"12:00 am",
                     end:"12:00 am",
                     frequency:"0 h 00",
                     stay_time:"0 h 00",
                    },
        tuesday:    {
                     begin:"12:00 am",
                     end:"12:00 am",
                     max_spaces:0,
                     frequency:"0 h 00",
                     stay_time:"0 h 00",
                    },
        wednesday:  {
                     begin:"12:00 am",
                     end:"12:00 am",
                     max_spaces:0,
                     frequency:"0 h 00",
                     stay_time:"0 h 00",
                    },
        thursday:   {
                     begin:"12:00 am",
                     end:"12:00 am",
                     max_spaces:0,
                     frequency:"0 h 00",
                     stay_time:"0 h 00",
                    },
        friday:     {
                     begin:"12:00 am",
                     end:"12:00 am",
                     max_spaces:0,
                     frequency:"0 h 00",
                     stay_time:"0 h 00",
                    },
        saturday:   {
                     begin:"12:00 am",
                     end:"12:00 am",
                     max_spaces:0,
                     frequency:"0 h 00",
                     stay_time:"0 h 00",
                    },
        sunday:     {
                     begin:"12:00 am",
                     end:"12:00 am",
                     max_spaces:0,
                     frequency:"0 h 00",
                     stay_time:"0 h 00",
                    }
      },
      maximum_spaces:{
        monday: 0,
        tuesday: 0,
        wednesday: 0,
        thursday: 0,
        friday:0,
        saturday:0,
        sunday:0
      },
      spacesInError:false,
      validate_quota: false,
      country: '',
      time_zone: '',
      location_time_zone: '',
      gtm: '',
      max_hh_minutes: 0,
      book_hh_minutes: 0,
      max_mm: 0,
      book_mm: 0,
      time_stay: 0,
      book_every: 0,
      book_every_minutes: 0,
      invalid_inactive_times: false,
      days_changed: [],
      show_advertisement_modal: false
    }
  },
  components: { VueTimepicker },
  computed:{
    formIsInError(){
      var ans=false
      if(this.scheduleIsInError||this.sublocation.attributes.name.length==0||this.spacesInError||this.invalid_inactive_times){
        ans=true
      }
      return ans
    },
    scheduleIsInError(){
      var ans=false
      if(this.errorOpening||this.errorEnding||this.spacesInError){
        ans=true
      }
      return ans
    },
    isWeekendActive(){
      var self=this;
      return this.locations.find(element => element.id == self.sublocation.attributes.location_id).schedule.works_on_sundays
    },
    startRange(){
      var self=this;
      let data= this.locations.find(element => element.id == self.sublocation.attributes.location_id).schedule[self.actual_day]
      return [data.beginning.hour, data.ending.hour]
    },
    endRange(){
      var self=this;
      let data= this.locations.find(element => element.id == self.sublocation.attributes.location_id).schedule[self.actual_day]
      let beg=data.beginning.hour;
      let myData= this.timeBoxes[this.actual_day]
      let bMyData= Number(this.convertDaytimeFormatToHour(myData.begin).split(":")[0])

      if(bMyData>beg){
        beg=bMyData;
      }
      let end=data.ending.hour

      return [beg,end]
    },
    startMinutesRange(){
      var self=this;
      let mins=[0,60]
      let data= this.locations.find(element => element.id == self.sublocation.attributes.location_id).schedule[self.actual_day]
      let myData= this.timeBoxes[this.actual_day]
      let arr=this.convertDaytimeFormatToHour(myData.begin).split(":")
      let beg=Number(arr[0])
      if(beg==data.beginning.hour){
        mins=[data.beginning.minute,60]
      }
      if(beg==data.ending.hour){
        mins=[mins[0],data.ending.minute]
      }
      return mins;
    },
    endMinutesRange(){
      var self=this;
      let mins=[0,60]
      let data= this.locations.find(element => element.id == self.sublocation.attributes.location_id).schedule[self.actual_day]
      let myData= this.timeBoxes[this.actual_day]
      let arr=this.convertDaytimeFormatToHour(myData.end).split(":")
      let arr2=this.convertDaytimeFormatToHour(myData.begin).split(":")
      let end=Number(arr[0])
      if(end==data.ending.hour){
        mins=[0,data.ending.minute]
      }
      if(end==Number(arr2[0])){
        mins=[Number(arr2[1]),mins[1]]
      }
      return mins;
    },
    bookEvery(){
      let hh = 0
      let mm = 0
      let t = this.timeBoxes[this.actual_day].stay_time
      let f = this.timeBoxes[this.actual_day].frequency
      let c = this.timeBoxes[this.actual_day].max_spaces
      let hh_t = parseInt(t.substring(0,t.indexOf('h') - 1))
      let mm_t = parseInt(t.substring(t.indexOf('h') + 2, t.length))
      let hh_f = parseInt(f.substring(0,f.indexOf('h') - 1))
      let mm_f = parseInt(f.substring(f.indexOf('h') + 2, f.length))
      this.time_stay = hh_t
      /* if (hh_f > 0 || mm_f > 0) {  */
        let total_stay_time = 0
        hh_t > 0 ? total_stay_time = ((hh_t * 60) + mm_t) : total_stay_time = mm_t
        let min_time = (total_stay_time / c)
          if (total_stay_time >= 60){
            hh = min_time / 60
            let minutes_decimal =  (hh - Math.floor(hh))
            mm = Math.floor((minutes_decimal * 60))
            this.book_mm = mm
            hh = Math.floor(hh)
          } else {
            mm = mm_t
            /* min_time */
            this.book_mm = mm
          }
        this.book_hh_minutes = ( hh * 60 ) + mm
      /* } */
      return { hh: [hh,23], mm: 55 }
    },
    maxTimeStay(){
      let hh = 23
      let mm = 55
      let t = this.timeBoxes[this.actual_day].stay_time
      let f = this.timeBoxes[this.actual_day].frequency
      let c = this.timeBoxes[this.actual_day].max_spaces
      let hh_f = parseInt(f.substring(0,f.indexOf('h') - 1))
      let mm_f = parseInt(f.substring(f.indexOf('h') + 2, f.length))
      this.book_every = hh_f
      this.book_every_minutes = mm_f
      if (hh_f > 0 || mm_f > 0) {
        let total_frequency = 0
        hh_f > 0 ? total_frequency = ((hh_f * 60) + mm_f) : total_frequency = mm_f
        let min_time = (total_frequency * c)
        if (min_time >= 60){
          hh = min_time  / 60
          let minutes_decimal =  (hh - Math.floor(hh))
          mm = Math.floor((minutes_decimal * 60))
          this.max_mm = mm;
          hh = Math.floor(hh)
        } else {
          hh = 0
          mm = min_time
          this.max_mm = mm
        }
        this.max_hh_minutes = ( hh * 60 ) + mm
        return { hh: [0,hh], mm: 0 }
      }
      return { hh: [0,hh], mm: 0 }
    },
    bookMM(){
      const minutes = this.book_hh_minutes
      console.log('########## this.book_hh_minutes ', this.book_hh_minutes)
      const current_minutes = (this.book_every * 60)
      console.log('########## current_minutes ', current_minutes)
      /* if (minutes < 60 ) return this.book_mm */
      return  minutes - current_minutes
    },
    maxMM(){
      const minutes = this.max_hh_minutes
      if (this.book_every === 0 && this.book_every_minutes === 0) return 60
      if (minutes < 60 ) return this.max_mm
      const current_minutes = (this.time_stay * 60)
      return minutes - current_minutes
    },
    timeZoneLocal: function(){
      let resolvedOptions = Intl.DateTimeFormat().resolvedOptions()
      return resolvedOptions.timeZone
    },
  },
  watch:{
    schedule_url(){
      // cl schedule_url
      this.schedule_url_change = true;
    },
    manager_url(){
      // cl manager_url
      if(this.manager_url != ''){
        this.manager_url_change = true;
      }
    },
  },
  mounted(){
    var path = this.$route.params.id
    var self=this;
    try {
      this.$http.get('sublocations/'+ path,{
          headers:{
            "X-Device-ID": this.getDeviceId(),
            "Authorization": 'Bearer ' + this.getUserToken()
          }
      })
      .then(function(response){
        console.log("=== Mounted Edit Sublocation === ", response)
        this.sublocation = response.body.data
        var myDays=response.body.meta.schedule
        this.locations=response.body.meta.locations
        this.locations.forEach(x=>{
          if(x.id==self.sublocation.attributes.location_id){
            self.originalLocation.name=x.name
            self.originalLocation.id=x.id
          }
        })

        let myLoc=this.locations.find(element => element.id == self.sublocation.attributes.location_id)
        this.country = myLoc.country
        this.time_zone = myLoc.time_zone
        console.log('=== time_zone === ', this.time_zone)
        this.location_time_zone = myLoc.time_zone.substring(myLoc.time_zone.indexOf('/') + 1,myLoc.time_zone.length).replace(/[_]/g,' ')
        this.gtm = myLoc.gtm.substring(0,3) + ":" + myLoc.gtm.substring(3,5)/* .replace(/[0]/g,'') */

        var new_schedules = Object.entries(myDays)
        var all_inactive_times = response.body.meta.inactive_times
        for (var i = 0; i < new_schedules.length; i++) {
          this.days[new_schedules[i][0]].begin =this.convertHourToStyleFormat(new_schedules[i][1].begin)
          this.days[new_schedules[i][0]].end =this.convertHourToStyleFormat(new_schedules[i][1].end)
          this.days[new_schedules[i][0]].max_spaces=new_schedules[i][1].max_spaces
          this.days[new_schedules[i][0]].frequency=this.convertDurationToStyleFormat(new_schedules[i][1].frequency)
          this.days[new_schedules[i][0]].stay_time=new_schedules[i][1].stay_time != undefined ? this.convertDurationToStyleFormat(new_schedules[i][1].stay_time) : "0 h 00"
          this.days[new_schedules[i][0]].spaces_per_booking=new_schedules[i][1].spaces_per_booking
          this.timeBoxes[new_schedules[i][0]].begin=this.days[new_schedules[i][0]].begin
          this.timeBoxes[new_schedules[i][0]].end=this.days[new_schedules[i][0]].end
          this.timeBoxes[new_schedules[i][0]].max_spaces=this.days[new_schedules[i][0]].max_spaces
          this.timeBoxes[new_schedules[i][0]].frequency=this.days[new_schedules[i][0]].frequency
          this.timeBoxes[new_schedules[i][0]].stay_time=this.days[new_schedules[i][0]].stay_time

          let inactive_times = []
          all_inactive_times.forEach((value, index) => {
            if(value.weekday === new_schedules[i][0]){
              var inactiveTime = {
                id: value.id,
                weekday: value.weekday,
                start_time: this.convertHourToStyleFormat(value.start_time),
                end_time: this.convertHourToStyleFormat(value.end_time),
                errorStart: false,
                errorEnd: false,
              }
              inactive_times.push(inactiveTime)
            }
          });
          this.days[new_schedules[i][0]].inactive_times = inactive_times

          var max=this.locations.find(element => element.id == self.sublocation.attributes.location_id).schedule[new_schedules[i][0]].max_spaces
          var used=this.locations.find(element => element.id == self.sublocation.attributes.location_id).occupied_spaces[new_schedules[i][0]]
          let myTotalDaySpaces=max-used+Number(this.days[new_schedules[i][0]].max_spaces)
          this.maximum_spaces[new_schedules[i][0]]=myTotalDaySpaces

        }
        this.setNewSpaces();
        this.charged = true
      //   this.image_url = this.location.attributes.image ? this.getImageServer() + this.location.attributes.image.url : ''
      //   this.schedule_url = this.location.attributes.schedule_image.url!=null ? this.getImageServer() + this.location.attributes.schedule_image.url : ''
      //   this.manager_url = this.location.attributes.manager_image.url!=null ? this.getImageServer() + this.location.attributes.manager_image.url : ''
      //   this.qr_text = this.location.id
      //   this.url = this.getImageServer() + this.location.attributes.image.url
      //   this.url_change = true
      //   if (response.body.included != null){
      //     var schedules = response.body.included.filter(object => object.type == 'location_schedules')[0].attributes
      //     this.works_on_sundays = schedules.works_on_sundays
      //     this.works_on_holidays = schedules.works_on_holidays
      //     // var new_schedules = schedules.map(object => object.begin != null )
      //     var new_schedules = Object.entries(schedules)
      //     new_schedules = new_schedules.filter(object => object[1].begin != null && object[1].end != null )
      //     console.log(new_schedules);
      //     for (var i = 0; i < new_schedules.length; i++) {
      //       this.days[new_schedules[i][0]].begin =
      //         new_schedules[i][1].begin.hour < 10 ?
      //           '0' + new_schedules[i][1].begin.hour + ':' +new_schedules[i][1].begin.minute.toString().padStart(2,"0") :
      //                 new_schedules[i][1].begin.hour + ':'+new_schedules[i][1].begin.minute.toString().padStart(2,"0")
      //       this.days[new_schedules[i][0]].end =
      //         new_schedules[i][1].end.hour < 10 ?
      //         '0' + new_schedules[i][1].end.hour + ':' + new_schedules[i][1].end.minute.toString().padStart(2,"0")   :
      //               new_schedules[i][1].end.hour + ':' + new_schedules[i][1].end.minute.toString().padStart(2,"0");
      //       this.days[new_schedules[i][0]].max_spaces=new_schedules[i][1].max_spaces
      //       this.timeBoxes[new_schedules[i][0]].begin=this.convertHourToStyleFormat(this.days[new_schedules[i][0]].begin)
      //       this.timeBoxes[new_schedules[i][0]].end=this.convertHourToStyleFormat(this.days[new_schedules[i][0]].end)
      //     }
      //   }

      }, function(response){
        if(response.body.meta != undefined && response.body.meta != null){
          if(response.body.meta.authentication_token != undefined && response.body.meta.authentication_token != null){
            this.checkToken(response.body.meta.authentication_token)
          }
        }
        if(typeof response.body.errors[0].details != "object"){
          alert(response.body.errors[0].details);
        }else{
          let message = []
          for(var key in response.body.errors[0].details){
            message.push(response.body.errors[0].details[key])
          }
          alert(message);
        }
      })
      } catch (e) {
        alert(e.message)
      }
  },
  methods:{
    checkOpening(){
      let times=this.timeBoxes[this.actual_day]
      let begin= this.convertDaytimeFormatToHour(times.begin)
      if(begin.includes("NaN")){
        this.errorOpening=true;
      }else{
        this.errorOpening=false;
      }
      this.reviewTimes()
    },
    checkEnding(){
      let times=this.timeBoxes[this.actual_day]
      let end= this.convertDaytimeFormatToHour(times.end)
      if(end.includes("NaN")){
        this.errorEnding=true;
      }else{
        this.errorEnding=false;
      }

      this.reviewTimes()
      this.updateShowModal()
    },
    reviewTimes(){
      let times=this.timeBoxes[this.actual_day]
      var self= this
      var myData={}

      var myLocation=this.locations.find(element => element.id == self.sublocation.attributes.location_id).schedule[self.actual_day]
      myData.begin= this.convertDaytimeFormatToHour(times.begin)
      myData.end= this.convertDaytimeFormatToHour(times.end)

      let beginArr=myData.begin.toString().split(":")
      let endArr=myData.end.toString().split(":")

      if(myData.begin.includes("NaN") ||
         Number(beginArr[0])<myLocation.beginning.hour ||
        (Number(beginArr[0])==myLocation.beginning.hour && Number(beginArr[1])<myLocation.beginning.minute)){
        myData.begin= myLocation.beginning.hour.toString().padStart(2,"0")+":"+myLocation.beginning.minute.toString().padStart(2,"0");
      }
      if(myData.end.includes("NaN") ||
         Number(endArr[0])>myLocation.ending.hour ||
        (Number(endArr[0])==myLocation.ending.hour && Number(endArr[1])>myLocation.ending.minute)){
        myData.end= myLocation.ending.hour.toString().padStart(2,"0")+":"+myLocation.ending.minute.toString().padStart(2,"0");
      }

      if(
         Number(beginArr[0])>myLocation.ending.hour ||
        (Number(beginArr[0])==myLocation.ending.hour && Number(beginArr[1])>myLocation.ending.minute)){
         myData.begin= myLocation.ending.hour.toString().padStart(2,"0")+":"+myLocation.ending.minute.toString().padStart(2,"0");
      }
      if(
         Number(endArr[0])<myLocation.beginning.hour ||
        (Number(endArr[0])==myLocation.beginning.hour && Number(endArr[1])<myLocation.beginning.minute)){
        myData.end= myData.begin
      }

      if(myData.begin>myData.end){
        myData.end=myData.begin
      }
      this.timeBoxes[this.actual_day].begin=this.convertHourToStyleFormat(myData.begin)
      this.timeBoxes[this.actual_day].end=this.convertHourToStyleFormat(myData.end)
      this.days[this.actual_day].begin=this.convertHourToStyleFormat(myData.begin)
      this.days[this.actual_day].end=this.convertHourToStyleFormat(myData.end)

      this.setNewSpaces()
    },
    checkSchedule () {
      var vm = this
      Object.keys(vm.days).forEach(function (key) {
        if (vm.days[key].begin == '' || vm.days[key].end == '') {
          delete vm.days[key]
        }
      });
    },
    isNumberValid(evt){
        evt = (evt) ? evt : window.event;
        var charCode = (evt.which) ? evt.which : evt.keyCode;
        if (charCode > 31 && (charCode < 48 || charCode > 57)) {
            evt.preventDefault();;
        }else {
            return true;
        }
    },
    isFinalNumberValid(myData,day){
        if(myData.target.value.length==0){
          day.max_spaces=0;
        }else{
          if(day.max_spaces.toString()[0]=="0"&&day.max_spaces.length>0){
            day.max_spaces= Number(day.max_spaces.replace(/^0+/, ''));
          }
        }
    },

    reviewSpaces(){
      let data=this.days[this.actual_day]
      if(data.max_spaces>this.maximum_spaces[this.actual_day] ||data.max_spaces<0){
        this.spacesInError=true;
      }else{
        this.spacesInError=false;
      }
      this.setNewSpaces();
    },

    setNewSpaces(){
      let data=this.timeBoxes[this.actual_day]
      var myData={};
      myData.frequency=this.convertDurationFormat(data.frequency)
      myData.stay_time=this.convertDurationFormat(data.stay_time)

      myData.begin= this.convertDaytimeFormatToHour(data.begin)
      myData.end= this.convertDaytimeFormatToHour(data.end)
      myData.max_spaces=data.max_spaces
      this.days[this.actual_day].spaces_per_booking=this.getConcurrentClassTimes(myData)
      this.getConcurrentClassTimes(myData) === 0 && data.max_spaces > 0 ? this.validate_quota = true : this.validate_quota = false
      this.updateShowModal()
    },
    getConcurrentClassTimes(data){
      var concurrentBookings=this.recurrentScheduleCounter(data.begin,
                                    this.addHours(data.begin,data.stay_time),
                                    data.end,data.begin,data.frequency,
                                    data.stay_time)
      let ans=data.max_spaces
      if(concurrentBookings>1){
        ans=Math.floor(data.max_spaces/concurrentBookings)
      }else if(concurrentBookings==0){
        ans=0
      }
      return ans;
    },
    recurrentScheduleCounter(firstHour,firstEnd,endHour,hour,freq, period){
      if(
         (!this.firstIsGreaterThanSecond(firstEnd,hour) && firstHour!=hour)||
         this.firstIsGreaterThanSecond(this.addHours(hour,period),endHour) ||
         this.firstIsGreaterThanSecond(firstHour,hour) || period=="0:00"
        ){
        return 0
      }else if(freq=="0:00"){
        return 1
      }
      else{
        return 1+this.recurrentScheduleCounter( firstHour, firstEnd, endHour,
                                                this.addHours(hour,freq),
                                                freq, period
                                              )
      }
    },
    validateScheduleChanges(){
      if(this.days_changed.length > 0){
        this.show_advertisement_modal = true
      }else{
        this.show_advertisement_modal = false
        this.editLocation()
      }
    },
    editLocation(){
      // this.checkSchedule()
      this.setDaysWithNewTimes();
      this.sublocation.attributes.sublocation_schedule_attributes = this.days

      try {
        this.$http.patch('sublocations/'+ this.sublocation.id, {data: this.encrypt(this.sublocation).toString()},
          {headers:
            {"X-Device-ID" : this.getDeviceId(),
            "Authorization" : 'Bearer ' + this.getUserToken()}})
        .then(function(response){
          if(response.body.meta != undefined && response.body.meta != null){
            if(response.body.meta.authentication_token != undefined && response.body.meta.authentication_token != null){
              this.checkToken(response.body.meta.authentication_token)
            }
          }
          this.$router.push({name: 'sublocations', params: {id: response.data.data.attributes.location_id}})
        }, function(response){
          if(response.body.meta != undefined && response.body.meta != null){
            if(response.body.meta.authentication_token != undefined && response.body.meta.authentication_token != null){
              this.checkToken(response.body.meta.authentication_token)
            }
          }
          if(typeof response.body.errors[0].details != "object"){
            alert(response.body.errors[0].details);
          }else{
            let message = []
            for(var key in response.body.errors[0].details){
              message.push(response.body.errors[0].details[key])
            }
            alert(message);
          }
        })
      } catch (e) {
        alert(e.message)
      }
    },
    convertHourToStyleFormat(hour){
      var arr=hour.split(":")
      var amOrPm="am"
      if(arr[0]>=12){
        amOrPm="pm"
        if(arr[0]>12){
          arr[0]= Number(arr[0])%12
        }
      }else if(arr[0]==0){
        arr[0]=12
      }
      if(Number(arr[0])<10){
        arr[0]="0"+Number(arr[0]).toString()
      }
      return arr[0]+":"+arr[1]+" "+amOrPm;
    },
    convertDurationToStyleFormat(hour){
      if (hour !== null){
        var arr=hour.split(":")
        return arr[0]+" h "+arr[1].toString().padStart(2,"0");
      }
    },
    setDaysWithNewTimes(){
      var myConversion=function convertStyleFormatToHour(hour){
        var arr=hour.split(":")
        let hours=Number(arr[0])
        let secondArr=arr[1].split(" ")
        var minutes=secondArr[0]
        var amOrPm=secondArr[1]
        var finalHour=[hours,minutes]

        if(amOrPm=="pm" && hours!=12){
          finalHour[0]= (Number(hours)+12)%24
        }else if(hours==12 && amOrPm=="am" ){
          finalHour[0]=0
        }
        return finalHour[0].toString().padStart(2,"0")+":"+finalHour[1].toString().padStart(2,"0");
      }
      var myHourConversion= function convertFormatToSend(time){
        let arr=time.split(" h ")
        return arr[0]+":"+arr[1].toString().padStart(2,"0");
      }
      for(var key in this.timeBoxes){
        this.days[key].begin=myConversion(this.timeBoxes[key].begin);
        this.days[key].end=myConversion(this.timeBoxes[key].end);
        this.days[key].max_spaces=this.timeBoxes[key].max_spaces;
        this.days[key].frequency=myHourConversion(this.timeBoxes[key].frequency);
        this.days[key].stay_time=myHourConversion(this.timeBoxes[key].stay_time);

        this.days[key].inactive_times.forEach((value, index) => {
          value.start_time = myConversion(value.start_time);
          value.end_time = myConversion(value.end_time);
        });
      }
    },
    addInactiveTime(day_name){
      var inactiveTime = {
        weekday: day_name,
        start_time: this.timeBoxes[day_name].begin,
        end_time: this.timeBoxes[day_name].begin,
        errorStart: false,
        errorEnd: false
      }
      this.days[day_name].inactive_times.push(inactiveTime);
    },
    removeInactiveTime(day_name, index) {
      this.days[day_name].inactive_times.splice(index, 1)
      this.validateInactiveTimes()
    },
    validateInactiveTimes(){
      this.days[this.actual_day].inactive_times.forEach((value, i) => {
        this.inactiveTimeValidations(i)
      });
    },
    inactiveTimeValidations(index){
      let times=this.days[this.actual_day].inactive_times[index]
      var self= this
      var myData={}

      let beginInRange = 0
      let endInRange = 0

      var myLocation=this.locations.find(element => element.id == self.sublocation.attributes.location_id).schedule[self.actual_day]
      myData.begin= this.convertDaytimeFormatToHour(times.start_time)
      myData.end= this.convertDaytimeFormatToHour(times.end_time)

      let beginArr=myData.begin.toString().split(":")
      let endArr=myData.end.toString().split(":")

      if(myData.begin.includes("NaN") ||
         Number(beginArr[0])<myLocation.beginning.hour ||
        (Number(beginArr[0])==myLocation.beginning.hour && Number(beginArr[1])<myLocation.beginning.minute)){
        myData.begin= myLocation.beginning.hour.toString().padStart(2,"0")+":"+myLocation.beginning.minute.toString().padStart(2,"0");
      }
      if(myData.end.includes("NaN") ||
         Number(endArr[0])>myLocation.ending.hour ||
        (Number(endArr[0])==myLocation.ending.hour && Number(endArr[1])>myLocation.ending.minute)){
        myData.end= myLocation.ending.hour.toString().padStart(2,"0")+":"+myLocation.ending.minute.toString().padStart(2,"0");
      }
      if(
         Number(beginArr[0])>myLocation.ending.hour ||
        (Number(beginArr[0])==myLocation.ending.hour && Number(beginArr[1])>myLocation.ending.minute)){
         myData.begin= myLocation.ending.hour.toString().padStart(2,"0")+":"+myLocation.ending.minute.toString().padStart(2,"0");
      }
      if(
         Number(endArr[0])<myLocation.beginning.hour ||
        (Number(endArr[0])==myLocation.beginning.hour && Number(endArr[1])<myLocation.beginning.minute)){
        myData.end= myData.begin
      }

      if(myData.begin>myData.end){
        myData.end=myData.begin
      }

      this.days[this.actual_day].inactive_times.forEach((value, i) => {
        if(index != i){
          var valueBegin = this.convertDaytimeFormatToHour(value.start_time)
          var compareBegin = valueBegin.toString().split(":")
          var valueEnd = this.convertDaytimeFormatToHour(value.end_time)
          var compareEnd = valueEnd.toString().split(":")
          if(Number(beginArr[0]) > Number(compareBegin[0]) && Number(beginArr[0]) < Number(compareEnd[0]) ||
          (Number(beginArr[0]) == Number(compareBegin[0]) && Number(beginArr[1]) >= Number(compareBegin[1])) && (Number(beginArr[0]) < Number(compareEnd[0])) ||
          (Number(beginArr[0]) == Number(compareEnd[0]) && Number(beginArr[1]) <= Number(compareEnd[1])) ){
            beginInRange++
          }
          if(Number(endArr[0]) > Number(compareBegin[0]) && Number(endArr[0]) < Number(compareEnd[0]) ||
          (Number(endArr[0]) == Number(compareBegin[0]) && Number(endArr[1]) >= Number(compareBegin[1])) && (Number(endArr[0]) <= Number(compareEnd[0]) && Number(endArr[1]) <= Number(compareEnd[1])) ||
          (Number(endArr[0]) == Number(compareBegin[0]) && Number(endArr[1]) >= Number(compareBegin[1])) && Number(endArr[0]) <= Number(compareEnd[0]) ){
            endInRange++
          }
          if(Number(beginArr[0]) < Number(compareBegin[0]) && Number(endArr[0]) > Number(compareEnd[0]) ||
          (Number(beginArr[0]) <= Number(compareBegin[0]) && Number(beginArr[1]) <= Number(compareBegin[1]) ) && (Number(endArr[0]) >= Number(compareEnd[0]) && Number(endArr[1]) >= Number(compareEnd[1])) ||
          (Number(endArr[0]) >= Number(compareBegin[0]) && Number(endArr[1]) >= Number(compareBegin[1]) ) && (Number(endArr[0]) <= Number(compareEnd[0]) && Number(endArr[1]) <= Number(compareEnd[1])) ||
          (Number(beginArr[0]) <= Number(compareBegin[0]) && Number(beginArr[1]) <= Number(compareBegin[1]) ) && Number(endArr[0]) > Number(compareEnd[0]) ){
            beginInRange++
            endInRange++
            console.log('if 3')
            console.log('hora seleccionada inicio', beginArr[0])
            console.log('minutos seleccionados inicio', beginArr[1])
            console.log('hora seleccionada fin', endArr[0])
            console.log('minutos seleccionados fin', endArr[1])
            console.log('hora seleccionada inicio', compareBegin[0])
            console.log('minutos seleccionados inicio', compareBegin[1])
            console.log('hora seleccionada fin', compareEnd[0])
            console.log('minutos seleccionados fin', compareEnd[1])
          }
        }
      });

      if(beginInRange > 0 || endInRange > 0){
        if(beginInRange > 0){
          this.days[this.actual_day].inactive_times[index].errorStart = true
        }else{
          this.days[this.actual_day].inactive_times[index].errorStart = false
        }
        if(endInRange > 0){
          this.days[this.actual_day].inactive_times[index].errorEnd = true
        }else{
          this.days[this.actual_day].inactive_times[index].errorEnd = false
        }
        this.invalid_inactive_times = true
      }else{
        this.invalid_inactive_times = false
        this.days[this.actual_day].inactive_times[index].errorStart = false
        this.days[this.actual_day].inactive_times[index].errorEnd = false
      }

      this.days[this.actual_day].inactive_times[index].start_time=this.convertHourToStyleFormat(myData.begin)
      this.days[this.actual_day].inactive_times[index].end_time=this.convertHourToStyleFormat(myData.end)
    },
    updateShowModal(){
      // console.log('days', this.days)
      // console.log('timeboxes', this.timeBoxes)
      let d_begin = false;
      let d_end = false;
      let d_max_spaces = false;
      let d_frequency = false;
      let d_stay_time = false;
      var myConversion=function convertStyleFormatToHour(hour){
        var arr=hour.split(":")
        let hours=Number(arr[0])
        let secondArr=arr[1].split(" ")
        var minutes=secondArr[0]
        var amOrPm=secondArr[1]
        var finalHour=[hours,minutes]

        if(amOrPm=="pm" && hours!=12){
          finalHour[0]= (Number(hours)+12)%24
        }else if(hours==12 && amOrPm=="am" ){
          finalHour[0]=0
        }
        return finalHour[0].toString().padStart(2,"0")+":"+finalHour[1].toString().padStart(2,"0");
      }
      var myHourConversion= function convertFormatToSend(time){
        let arr=time.split(" h ")
        return arr[0]+":"+arr[1].toString().padStart(2,"0");
      }
      let begin_changed = myConversion(this.timeBoxes[this.actual_day].begin);
      let end_changed = myConversion(this.timeBoxes[this.actual_day].end);
      let max_spaces_changed = parseInt(this.timeBoxes[this.actual_day].max_spaces)
      let frequency_changed = myHourConversion(this.timeBoxes[this.actual_day].frequency);
      let stay_time_changed = myHourConversion(this.timeBoxes[this.actual_day].stay_time);

      let begin_initial = myConversion(this.days[this.actual_day].begin);
      let end_initial = myConversion(this.days[this.actual_day].end);
      let max_spaces_initial = parseInt(this.days[this.actual_day].max_spaces)
      let frequency_initial = myHourConversion(this.days[this.actual_day].frequency);
      let stay_time_initial = myHourConversion(this.days[this.actual_day].stay_time);

      if(begin_changed > begin_initial){
        d_begin = true
      }else{
        d_begin = false
      }
      if(end_changed < end_initial){
        d_end = true
      }else{
        d_end = false
      }
      if(max_spaces_changed != max_spaces_initial){
        d_max_spaces = true
      }else{
        d_max_spaces = false
      }
      if(frequency_changed != frequency_initial){
        d_frequency = true
      }else{
        d_frequency = false
      }
      if(stay_time_changed != stay_time_initial){
        d_stay_time = true
      }else{
        d_stay_time = false
      }

      if (d_begin || d_end || d_max_spaces || d_frequency || d_stay_time)
      {
        if(!this.days_changed.find(day => day === this.actual_day))
          this.days_changed.push(this.actual_day)
      }else{
        var removeItemFromArr = ( arr, item ) => {
            var i = arr.indexOf( item );
            i !== -1 && arr.splice( i, 1 );
        };
        removeItemFromArr(this.days_changed, this.actual_day );
      }
      // console.log("días cambiados", this.days_changed);
    },
    confirmSave(action){
      if(action){
        this.editLocation()
      }else{
        this.show_advertisement_modal = false
      }
    }

  }
}
</script>



// WEBPACK FOOTER //
// src/components/views/locations/sublocations/Edit_sublocation.vue